export default __webpack_public_path__ + "static/media/2d-pvp.69e291ce.webm";